import { render, staticRenderFns } from "./storyIFrame.vue?vue&type=template&id=20f8f28a&scoped=true&lang=true&"
import script from "./storyIFrame.vue?vue&type=script&lang=js&"
export * from "./storyIFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f8f28a",
  null
  
)

export default component.exports